/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class CreditRatingGrid extends SiteEntityGrid<CreditRatingRow, any> {
        protected getColumnsKey() { return 'Data.CreditRating'; }
        protected getDialogType() { return CreditRatingDialog; }
        protected getIdProperty() { return CreditRatingRow.idProperty; }
        protected getLocalTextPrefix() { return CreditRatingRow.localTextPrefix; }
        protected getService() { return CreditRatingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}